import { getRootUrl } from '@bingads-webui-react/copilot-utils';
import { getBotMtApiUrl } from './utils/xandr-bot-mt';
import type { ConversationRequestContext, RequestHeaders } from './types';

export type IResumeConversationProps = ConversationRequestContext;


function resumeConversationUrl({
  cid,
  uid,
  conversationId,
  productName,
}: IResumeConversationProps) {
  if (productName === 'xandr_curate' || productName === 'xandr_monetization') {
    // need to bypass /tokenexchange for xandr products, default to token exchange for all others
    return `${getBotMtApiUrl()}/chathistory/resume?userId=${encodeURIComponent(uid)}&customerId=${encodeURIComponent(cid)}&conversationId=${encodeURIComponent(conversationId)}`;
  }
  return `${getRootUrl()}/tokenexchange/chatresume?uid=${encodeURIComponent(uid)}&cid=${encodeURIComponent(cid)}&conversationId=${encodeURIComponent(conversationId)}`;
}

function activitiesUrl({
  conversationId,
}: {
  conversationId: string;
}) {
  return `https://directline.botframework.com/v3/directline/conversations/${encodeURIComponent(conversationId)}/activities`;
}

export async function resumeConversation({
  cid,
  uid,
  conversationId,
  productName,
  authToken,
}: IResumeConversationProps) {
  const url = resumeConversationUrl({
    cid, uid, conversationId, productName,
  });
  const isXandrProduct = productName === 'xandr_curate' || productName === 'xandr_monetization';
  const headers: RequestHeaders = {
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest',
  };
  if (isXandrProduct && authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  return window.fetch(url, {
    method: 'POST',
    headers,
    credentials: isXandrProduct ? 'omit' : 'include',
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorText = await response.text();
        return {
          hasError: true,
          message: 'Failed to resume conversation',
          error: `Error: ${errorText}`,
        };
      }

      const data = await response.json();

      const token = data?.token ?? data?.Token;
      const convId = data?.conversationId ?? data?.ConversationId;

      if (!token || !convId) {
        return {
          hasError: true,
          message: `Resume response missing required fields for requested conversation: ${conversationId}`,
          error: `Response missing required fields. token present: ${!!token}, conversationId present: ${!!convId}`,
        };
      }

      const activitiesResponse = await fetch(activitiesUrl({ conversationId: convId }), {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!activitiesResponse.ok) {
        const error = `HTTP error! status: ${activitiesResponse.status}`;
        return {
          hasError: true,
          message: `Failed to resume conversation: ${conversationId} HTTP error! status: ${activitiesResponse.status}`,
          error,
        };
      }

      return {
        success: true,
        token,
        conversationId: convId,
      };
    })
    .catch(error => ({
      hasError: true,
      message: 'Failed to resume conversation',
      error: error?.message,
    }));
}
